export var Alignments;

(function (Alignments) {
  Alignments["CENTER"] = "center";
  Alignments["LEFT"] = "left";
  Alignments["RIGHT"] = "right";
})(Alignments || (Alignments = {}));